import { gql } from 'apollo-boost';
export const SEARCH_LEADERS = gql`
  query LEADERS {
    leaders {
      total
      page
      docs {
        id
        firstName
        lastName
        avatar
      }
    }
  }
`;

export const LEADER = gql`
  query LEADER($id: ID) {
    leader(id: $id) {
      id
      firstName
      lastName
      email
      phone
      avatar
      bio
    }
  }
`;

export const UPDATE_LEADER = gql`
  mutation UPDATE_LEADER($id: ID, $input: LeaderInput) {
    updateLeader(id: $id, input: $input) {
      id
    }
  }
`;

export const ADD_LEADER = gql`
  mutation ADD_LEADER($input: LeaderInput) {
    addLeader(input: $input) {
      id
    }
  }
`;
